const WEB_DEVICE_ID_STORAGE_KEY = 'intimsync.web.device_id.v1';

export function getOrCreateWebDeviceId() {
  try {
    const existing = window.localStorage.getItem(WEB_DEVICE_ID_STORAGE_KEY);
    if (existing && existing.trim()) return existing;

    const randomId =
      typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : `${Date.now()}_${Math.random().toString(36).slice(2, 12)}`;

    const next = `web:${randomId}`;
    window.localStorage.setItem(WEB_DEVICE_ID_STORAGE_KEY, next);
    return next;
  } catch {
    return 'web:unknown';
  }
}
